import { create } from 'zustand';

type PageState = {
  // Which page is open. The page data itself lives in the query cache
  // (pageKeys.detail) and is read through useCurrentPage.
  currentPageId: string | null;
  isDirty: boolean;
  editable: boolean;
  currentPageVersion: number;

  setCurrentPageId: (id: string | null) => void;
  setIsDirty: (isDirty: boolean) => void;
  setEditable: (editable: boolean) => void;
  updatePageVersion: () => void;
};

const getInitialEditable = (): boolean => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('editable') !== 'false';
  }
  return true;
};

export const usePageStore = create<PageState>(set => ({
  currentPageId: null,
  isDirty: false,
  editable: getInitialEditable(),
  currentPageVersion: 0,

  setCurrentPageId: currentPageId => {
    set({ currentPageId });
  },
  setIsDirty: isDirty => {
    set({ isDirty });
  },
  setEditable: editable => {
    set({ editable });
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('editable', String(editable));
    }
  },
  updatePageVersion: () => {
    set(state => ({
      currentPageVersion: state.currentPageVersion + 1,
    }));
  },
}));
